import type { ObjectId } from "@bbj-types/utils";
import { useStableCallback } from "@root/utils/hooks/useStableCallback";
import { axios } from "../../axios";
import type { TPostCandidateFetchBody } from "./types";

export interface IPostCandidatesFetchAuthors {
  _id: ObjectId;
  firstName: string;
  lastName: string;
  isDisabled: boolean;
  teams: {
    _id: ObjectId;
    name: string;
  }[];
}

export const usePostCandidatesFetchAuthors = () => {
  const [state, execute, cancel] = axios<IPostCandidatesFetchAuthors[], TPostCandidateFetchBody, unknown>(
    {
      url: "/candidates/fetch/authors",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useStableCallback((candidateIds: ObjectId[]) => {
    return execute({
      data: {
        candidateIds,
      },
    });
  });

  return [state, callback, cancel] as const;
};
